// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O_DDA","colMin":"styles_colMin__2OIfn"};